var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTiktokInvCircled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 209 209",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "matrix(4.166667,0,0,4.166667,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.34526,0,0,0.34526,-284.066213,-102.68097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.171,439.823C856.504,439.823 825.158,408.479 825.158,369.812C825.158,331.145 856.504,299.8 895.171,299.8C933.837,299.8 965.183,331.145 965.183,369.812C965.183,408.479 933.837,439.823 895.171,439.823Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.411148,0,0,0.411148,-343.047943,-127.047414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M936.793,348.111C925.108,348.111 915.636,338.639 915.636,326.954L899.769,326.954L899.769,388.367C899.769,395.508 893.98,401.297 886.84,401.297C879.699,401.297 873.91,395.508 873.91,388.367C873.91,381.227 879.699,375.438 886.84,375.438C888.179,375.438 889.695,375.642 890.91,376.02L890.91,359.856C889.58,359.668 888.222,359.571 886.84,359.571C870.936,359.571 858.043,372.463 858.043,388.367C858.043,404.271 870.936,417.164 886.84,417.164C902.743,417.164 915.636,404.271 915.636,388.367L915.636,355.863C921.404,360.568 928.769,363.391 936.793,363.391L936.793,348.111Z",
    style: {
      fill: "rgb(255,19,82)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.411148,0,0,0.411148,-343.047943,-127.047414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M932.298,343.616C920.613,343.616 911.142,334.144 911.142,322.459L895.273,322.459L895.273,383.873C895.273,391.013 889.485,396.802 882.345,396.802C875.204,396.802 869.416,391.013 869.416,383.873C869.416,376.732 875.204,370.943 882.345,370.943C883.684,370.943 885.2,371.147 886.415,371.525L886.415,355.361C885.085,355.173 883.727,355.076 882.345,355.076C866.44,355.076 853.548,367.969 853.548,383.873C853.548,399.776 866.44,412.669 882.345,412.669C898.249,412.669 911.142,399.776 911.142,383.873L911.142,351.368C916.91,356.073 924.273,358.896 932.298,358.896L932.298,343.616Z",
    style: {
      fill: "rgb(0,241,234)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.411148,0,0,0.411148,-343.047943,-127.047414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M932.298,347.628C927.184,346.521 922.758,343.567 919.756,339.496C915.686,336.494 912.731,332.069 911.624,326.954L899.769,326.954L899.769,388.367C899.769,395.508 893.98,401.297 886.84,401.297C882.116,401.297 877.986,398.763 875.73,394.981C871.949,392.726 869.416,388.596 869.416,383.873C869.416,376.732 875.204,370.943 882.345,370.943C883.684,370.943 885.2,371.147 886.415,371.525L886.415,359.576C870.707,359.804 858.043,372.605 858.043,388.367C858.043,395.174 860.406,401.429 864.355,406.357C869.284,410.306 875.538,412.669 882.345,412.669C898.249,412.669 911.142,399.776 911.142,383.873L911.142,351.368C916.91,356.073 924.273,358.896 932.298,358.896L932.298,347.628Z",
    style: {
      fillRule: "nonzero"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTiktokInvCircled);
export default __webpack_public_path__ + "static/media/ic_tiktok_inv_circled.5d9b80cc7a6fabafbee0d4316ea5a4d5.svg";
export { ForwardRef as ReactComponent };